import type { AxiosError } from 'axios';

import appMessage from '../../utils/appMessage';

interface ApiErrorBody {
  code?: string;
  message?: string;
}

const DEFAULT_FEATURE_UPGRADE_MESSAGE =
  'Este recurso não está disponível no seu plano. Faça upgrade para desbloquear.';

const DEDUP_MS = 2500;
let lastNotifiedAt = 0;

export const notifyFeatureNotAvailable = (customMessage?: string): void => {
  const now = Date.now();
  if (now - lastNotifiedAt < DEDUP_MS) return;
  lastNotifiedAt = now;
  appMessage.showWarning(customMessage ?? DEFAULT_FEATURE_UPGRADE_MESSAGE);
};

export const isFeatureNotAvailableError = (error: AxiosError): boolean => {
  if (error.response?.status !== 403) return false;
  const code = (error.response.data as ApiErrorBody | undefined)?.code;
  return code === 'FEATURE_NOT_AVAILABLE';
};

export const maybeNotifyFeatureNotAvailable = (error: AxiosError): boolean => {
  if (!isFeatureNotAvailableError(error)) return false;

  const body = error.response?.data as ApiErrorBody | undefined;
  const apiMessage =
    typeof body?.message === 'string' && body.message.trim().length > 0
      ? body.message.trim()
      : undefined;

  notifyFeatureNotAvailable(apiMessage);
  return true;
};
